import React from 'react';
import { Flex, Box } from 'theme-ui';
import Divider from '@solid-ui-components/Divider';
import FlexImage from '@solid-ui-components/FlexImage';
import FlexContent from '@solid-ui-components/FlexContent';
import ContentText from '@solid-ui-components/ContentText';
import ContentImages from '@solid-ui-components/ContentImages';
import ContentButtons from '@solid-ui-components/ContentButtons';
import WithDefaultContent from '@solid-ui-blocks/WithDefaultContent';
import Faq from '@solid-ui-blocks/Faq/Block01';
import Reveal from '@solid-ui-components/Reveal/Reveal';

const getBackgroundColorByVariant = (variant) => {
  switch (variant) {
    case 'green':
      return '#F6FDFD';
    case 'blue':
      return '#F5FBFF';
    case 'yellow':
      return '#FEFBE8';
    case 'purple':
      return '#FDF4FF';
  }
};

const FeaturesWithPhotoBlock09 = ({
  content: { text, images, collection, buttons },
  reverse,
  variant,
  centered = false,
}) => (
  <Box sx={{ position: 'relative' }}>
    <Flex
      sx={{
        alignItems: [null, centered ? 'center' : 'start'],
        flexDirection: [
          reverse ? 'column-reverse' : 'column',
          null,
          null,
          null,
          reverse ? 'row-reverse' : 'row',
        ],
        gap: [6, null, null, '132px'],
      }}
    >
      <FlexImage
        reverse={reverse}
        flexBasis={['100%', null, null, '55%']}
        order={[reverse ? -1 : 1, null, null, null, -1]}
      >
        <ContentImages content={{ images }} reverse={reverse} />
      </FlexImage>
      <FlexContent
        reverse={reverse}
        flexBasis={['100%', null, null, null, '45%']}
        width='100%'
      >
        <Box sx={{ textAlign: ['center', 'left'] }}>
          <ContentText content={text} />
        </Box>
        {collection && (
          <Box>
            <Faq content={{ collection, text: [] }} variant={variant} />
          </Box>
        )}
        {buttons && (
          <>
            <Divider space={3} />
            <Reveal effect='fadeInLeft'>
            <ContentButtons content={buttons} />
            </Reveal>
          </>
        )}
      </FlexContent>
    </Flex>
  </Box>
);

export default WithDefaultContent(FeaturesWithPhotoBlock09);
